<template>
  <div class="container">
    <div class="total-box">
      <div class="total-setting">
        <div class="title">Warning Step Setting</div>
        <div class="title-head">
          <p>Channel Stake Step%</p>
          <p>{{totalForm.stakeWarningStep}}</p>
        </div>
        <div class="title-head">
          <p>Channel PL Step%</p>
          <p>{{totalForm.warningStep}}</p>
        </div>
      </div>
      <div class="btn-wrapper">
        <el-button class="add-new-btn" @click="handleEdit()">
          <i style="font-size: 14px;" class="iconfont iconProperty1bi"></i> Edit
        </el-button>
      </div>
    </div>
    <div class="level-template">
      <div class="btn-wrapper">
        <el-button class="add-new-btn" @click="handleViewAdd(1)">
          <i class="iconfont iconProperty1tianjia"></i> Add
        </el-button>
      </div>
      <div class="risk-table risklist-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          :indent="0"
          v-loading="loading"
          header-row-class-name="table-header-row"
          border
          row-key="rowId"
          :tree-props="{children: 'childList', hasChildren: 'hasChildren'}"
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="ID" prop="id" min-width="50px" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{row.id}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Warning Template" min-width="130px" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{row.templateName}}</span>
                <!-- <span class="default" v-if="row.id == 1">Default 100%</span> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Channel Stake Warning %"
            prop="stakeWarning"
            min-width="165px"
            align="center"
          >
            <template v-slot="{row}">
              <div style="text-align: center;">{{+(row.stakeWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Channel PL Warning %" min-width="165px" align="center">
            <template v-slot="{row}">
              <div style="text-align: center;">{{+(row.profitWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="User Stake Warning %" min-width="190px" align="center">
            <template v-slot="{row}">
              <div style="text-align: center;">{{+(row.userStakeWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="User PL Warning %" prop="levelId" min-width="150px" align="left">
            <template v-slot="{row}">
              <div style="text-align: center;">{{+(row.userProfitWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Avg Stake Range" min-width="160px" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{row.configStakeMin}}～{{row.configStakeMax}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Remark" prop="remark" min-width="150px" align="left"></el-table-column>
          <el-table-column label="Operation" min-width="280px" align="center">
            <template v-slot="{row}">
              <div>
                <el-button class="table-inner-btn" @click="handleViewAdd(2,row)">Modify</el-button>
                <el-button class="table-inner-btn" @click="handleViewAdd(4,row)">History</el-button>
                <el-button class="table-inner-btn" @click="handleViewAdd(3,row)">Delete</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="total"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>-->
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <div>
        <el-form :model="totalForm" label-width="150px">
          <el-form-item label="Channel Stake Step%">
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="totalForm.stakeWarningStep"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Channel PL Step%">
            <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="totalForm.warningStep">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleModify(totalForm)">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
    <dia ref="diaListDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="queryForm" label-width="180px">
          <el-form-item label="Warning Template">
            <el-input v-model="queryForm.templateName"></el-input>
          </el-form-item>
          <el-form-item label="Channel Stake Warning %">
            <el-input
              v-model="queryForm.stakeWarning"
              type="number"
              @keypress.native="onlyPositiveNumbers"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Channel PL Warning %">
            <el-input
              v-model="queryForm.profitWarning"
              type="number"
              @keypress.native="onlyPositiveNumbers"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="User Stake Warning %">
            <el-input
              v-model="queryForm.userStakeWarning"
              type="number"
              @keypress.native="onlyPositiveNumbers"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="User PL Warning %">
            <el-input
              v-model="queryForm.userProfitWarning"
              type="number"
              @keypress.native="onlyPositiveNumbers"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Min Avg Stake">
            <el-input
              v-model="queryForm.configStakeMin"
              placeholder="1"
              type="number"
              @keypress.native="handleKeyPress"
            >
              <template slot="prepend">
                <span v-html="'&nbsp;&gt;&nbsp;'"></span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="Max Avg Stake">
            <el-input
              v-model="queryForm.configStakeMax"
              placeholder="1"
              type="number"
              @keypress.native="handleKeyPress1"
            >
              <template slot="prepend">
                <span v-html="'&lt;='"></span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="queryForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleListModify()">Confirm</el-button>
          <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
      </div>
      <!-- history4 -->
      <div v-if="num == 4">
        <el-table
          ref="table"
          :data="historyList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Modify Time" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{formatUtc(row.createTime)}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Warning Template Name" align="center">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{row.templateName}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Channel Stake Warning %" prop="stakeWarning" align="center">
            <template v-slot="{row}">
              <div>{{+(row.stakeWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Channel PL Warning %" prop="profitWarning" align="center">
            <template v-slot="{row}">
              <div>{{+(row.profitWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="User Stake Warning %" prop="userStakeWarning" align="center">
            <template v-slot="{row}">
              <div>{{+(row.userStakeWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="User PL Warning %" prop="userProfitWarning" align="center">
            <template v-slot="{row}">
              <div>{{+(row.userProfitWarning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Avg Stake Range" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{row.configStakeMin}}～{{row.configStakeMax}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Remark"
            :show-overflow-tooltip="true"
            prop="remark"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column label="Modifier" prop="operator" align="center" width="100"></el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryHistoryData.current"
            :page-size="queryHistoryData.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="CloseHistory()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>
<script>
import Empty from "@/components/empty/index";
import dia from "@/components/dialog/index";
import {
  getChannelDetailsList,
  updateBatchPublishGlobalSetting,
  publish,
  getWarningTemplateList,
  getWarningTemplateLogList,
  createWarningTemplate,
  updateWarningTemplate,
  removeWarningTemplate
} from "@/api/channel";
import { getRiskLevel } from "@/api/member";
export default {
  components: {
    Empty,
    dia
  },
  data() {
    return {
      list: [],
      status: false,
      levelList: [],
      total: 0,
      loading: false,
      loadingItem: false,
      historyList: [],
      totalAert: 0,
      num: "",
      templateId: "",
      totalForm: {
        stakeWarningStep: "",
        warningStep: ""
      },
      form: [
        { value: "", code: "", id: "" },
        { value: "", code: "", id: "" }
      ],
      data: [],
      queryForm: {
        id: "",
        templateName: "",
        stakeWarning: "",
        profitWarning: "",
        userStakeWarning: "",
        userProfitWarning: "",
        configStakeMin: "",
        configStakeMax: "",
        remark: ""
      },
      queryData: {
        current: 1,
        size: 100
      },
      queryHistoryData: {
        templateId: "",
        current: 1,
        size: 50
      },
      queryTotalData: {
        pageNum: 1,
        pageSize: 500
      },
      tableHeight: window.innerHeight
    };
  },
  mounted() {
    //this.getRiskLevel();
    this.getTotalSetting();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  methods: {
    onlyPositiveNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      const inputValue = event.target.value;

      // 允许的字符：数字（48-57），小数点（46），Backspace（8），Delete（127）
      if (
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 8 &&
        charCode !== 127
      ) {
        event.preventDefault();
      }

      // 只允许一个小数点
      if (inputValue.indexOf(".") !== -1 && charCode === 46) {
        event.preventDefault();
      }

      // 排除中文字符
      if (/[\u4E00-\u9FFF]/.test(String.fromCharCode(charCode))) {
        event.preventDefault();
      }
    },
    async getRiskLevel() {
      const res = await getRiskLevel();
      let data = res.data || {};
      let dataList = this.getArray(data);
      this.levelList = this.filterData(dataList);
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    filterData(data) {
      let res = data.filter(item => {
        let strArr = item.name.split("%");
        if (strArr.length > 1 && Number(strArr[0]) > 100) {
          return false;
        }
        return true;
      });
      return res;
    },
    async getList() {
      this.loading = true;
      const res = await getWarningTemplateList(this.queryData);
      this.list = res.data || [];
      this.total = Number(res.total);
      this.loading = false;
    },
    async getTotalSetting() {
      const res = await getChannelDetailsList(this.queryTotalData);
      const data = res.data.globalSettingDTOList || [];
      if (data.length > 0) {
        data.map(item => {
          if (item.code == "STAKE_WARNING_STEP") {
            this.totalForm.stakeWarningStep = +(item.value * 100).toFixed(4);
            this.form[0].value = item.value;
            this.form[0].code = item.code;
            this.form[0].id = item.id;
          }
          if (item.code == "WARNING_STEP") {
            this.totalForm.warningStep = +(item.value * 100).toFixed(4);
            this.form[1].value = item.value;
            this.form[1].code = item.code;
            this.form[1].id = item.id;
          }
        });
      }
    },
    fetchLevel(val, num) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
        if (num === 1) {
          if (!val) {
            name = "Default 100%";
          }
        }
      });
      return name;
    },
    handleEdit() {
      // 修改
      this.title = "Edit";
      this.$refs["dialogDom"].isShowDia(this.title, true, "600px");
    },
    // 修改
    async handleModify(data) {
      if (data.stakeWarningStep && data.warningStep) {
        this.form[0].value = data.stakeWarningStep / 100;
        this.form[1].value = data.warningStep / 100;
        const res = await updateBatchPublishGlobalSetting(this.form);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
        }
        this.getList();
        this.Close();
      } else {
        this.$message({
          message: "Must Input Total Alert Settings",
          type: "warning"
        });
        this.Close();
      }
    },
    // async publishFun() {
    //   const pub = await publish({});
    // },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "600px");
      this.getTotalSetting();
    },
    CloseHistory() {
      this.$refs["diaListDom"].isShowDia(this.title, false, "1400px");
    },
    handleKeyPress(event) {
      const charCode = event.which ? event.which : event.keyCode;
      const inputValue = event.target.value;

      // 允许的字符：数字（48-57），Backspace（8），Delete（127）
      if (
        (charCode < 48 || charCode > 57) &&
        charCode !== 8 &&
        charCode !== 127
      ) {
        event.preventDefault();
      }

      // 排除以0开头的非零正整数
      if (
        inputValue.startsWith("0") &&
        inputValue.length > 1 &&
        charCode !== 8 &&
        charCode !== 127
      ) {
        event.preventDefault();
      }
    },
    handleKeyPress1() {
      const charCode = event.which ? event.which : event.keyCode;
      const inputValue = event.target.value;

      // 允许的字符：数字（48-57），Backspace（8），Delete（127）
      if (
        (charCode < 48 || charCode > 57) &&
        charCode !== 8 &&
        charCode !== 127
      ) {
        event.preventDefault();
      }

      // 阻止以0开头的数字输入
      if (inputValue === "0" && charCode !== 8 && charCode !== 127) {
        event.preventDefault();
      }

      // 阻止以1-9之外的数字开头的输入
      if (inputValue.length === 0 && (charCode < 49 || charCode > 57)) {
        event.preventDefault();
      }
    },
    handleViewAdd(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Add Template";
        this.queryForm.templateName = "";
        this.queryForm.stakeWarning = "";
        this.queryForm.profitWarning = "";
        this.queryForm.userStakeWarning = "";
        this.queryForm.userProfitWarning = "";
        this.queryForm.configStakeMin = "";
        this.queryForm.configStakeMax = "";
        this.queryForm.remark = "";
        this.queryForm.id = "";
        this.$refs["diaListDom"].isShowDia(this.title, true, "600px");
      } else if (num == 2) {
        // 修改
        this.title = "Modify Template";
        this.queryForm.templateName = data.templateName;
        this.queryForm.stakeWarning = +(data.stakeWarning * 100).toFixed(4);
        this.queryForm.profitWarning = +(data.profitWarning * 100).toFixed(4);
        this.queryForm.userStakeWarning = +(
          data.userStakeWarning * 100
        ).toFixed(4);
        this.queryForm.userProfitWarning = +(
          data.userProfitWarning * 100
        ).toFixed(4);
        this.queryForm.configStakeMin = data.configStakeMin;
        this.queryForm.configStakeMax = data.configStakeMax;
        this.queryForm.remark = data.remark;
        this.queryForm.id = data.id;
        this.$refs["diaListDom"].isShowDia(this.title, true, "600px");
      } else if (num == 4) {
        this.queryHistoryData.current = 1;
        this.queryHistoryData.size = 50;
        this.title = "Warning Template History";
        this.queryHistoryData.templateId = data.id;
        this.$refs["diaListDom"].isShowDia(this.title, true, "1400px");
        this.getHistoryList();
      } else {
        // 删除
        this.title = "Delete Template?";
        this.templateId = data.id;
        this.$refs["diaListDom"].isShowDia(this.title, true, "600px");
      }
    },
    async getHistoryList() {
      this.loadingItem = true;
      try {
        const res = await getWarningTemplateLogList(this.queryHistoryData);
        const data = res.data || {};
        this.historyList = data.records || [];
        this.totalAert = Number(data.total);
        this.loadingItem = false;
      } catch (error) {
        this.historyList = [];
        this.loadingItem = false;
      }
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 分页
    changeAlertPage(e) {
      this.queryHistoryData.current = e;
      this.getHistoryList();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryHistoryData.size = e;
      this.queryHistoryData.current = 1;
      this.getHistoryList();
    },
    async handleListModify(data) {
      let stakeWarning = "";
      let profitWarning = "";
      let userStakeWarning = "";
      let userProfitWarning = "";
      if (this.queryForm.stakeWarning) {
        stakeWarning = this.queryForm.stakeWarning / 100;
      }
      if (this.queryForm.profitWarning) {
        profitWarning = this.queryForm.profitWarning / 100;
      }
      if (this.queryForm.userStakeWarning) {
        userStakeWarning = this.queryForm.userStakeWarning / 100;
      }
      if (this.queryForm.userProfitWarning) {
        userProfitWarning = this.queryForm.userProfitWarning / 100;
      }
      let param = {
        ...this.queryForm,
        stakeWarning: stakeWarning,
        profitWarning: profitWarning,
        userStakeWarning: userStakeWarning,
        userProfitWarning: userProfitWarning
      };
      if (!this.queryForm.templateName) {
        this.$message({
          message: "Warning Template Must not be empty",
          type: "error"
        });
        return;
      }
      if (!this.queryForm.stakeWarning) {
        this.$message({
          message: "Channel Stake Warning Must not be empty",
          type: "error"
        });
        return;
      }
      if (!this.queryForm.profitWarning) {
        this.$message({
          message: "Channel PL Warning Must not be empty",
          type: "error"
        });
        return;
      }
      if (!this.queryForm.userStakeWarning) {
        this.$message({
          message: "User Stake Warning Must not be empty",
          type: "error"
        });
        return;
      }
      if (!this.queryForm.userProfitWarning) {
        this.$message({
          message: "User PL Warning Must not be empty",
          type: "error"
        });
        return;
      }
      if (
        this.queryForm.configStakeMin == null ||
        this.queryForm.configStakeMin == ""
      ) {
        this.$message({
          message: "Min Avg Stake Must not be empty",
          type: "error"
        });
        return;
      }
      if (this.queryForm.id) {
        try {
          const res = await updateWarningTemplate(param);
          if (res.success) {
            this.$message({ message: "update success", type: "success" });
            this.getList();
            //this.publishFun();
            this.listClose();
          }
        } catch (error) {
          this.listClose();
        }
      } else {
        try {
          const res = await createWarningTemplate(param);
          if (res.success) {
            this.$message({ message: "create success", type: "success" });
            this.getList();
            //this.publishFun();
            this.listClose();
          }
        } catch (error) {
          this.listClose();
        }
      }
    },
    listClose() {
      this.$refs["diaListDom"].isShowDia(this.title, false, "600px");
    },
    // 删除
    async Delete() {
      const res = await removeWarningTemplate({ templateId: this.templateId });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.listClose();
      }
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 30px;
  line-height: 30px;
  .total-box {
    display: flex;
    align-items: flex-start;
    margin: 10px 0;
    .total-setting {
      display: flex;
      align-items: center;
      border: 1px solid #f5f5f5;
      border-radius: 10px;
      width: 1200px;
      height: 67px;
      margin-right: 20px;
      .title {
        width: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
        font-size: 16px;
        font-weight: 700;
        height: 65px;
        border-right: 1px solid #f5f5f5;
      }
      .title-head {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 65px;
        border-right: 1px solid #f5f5f5;
        &:last-child {
          border: none;
        }
        p {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 33px;
          color: #666;
          font-size: 12px;
          &:first-child {
            border-bottom: 1px solid #f5f5f5;
            color: #333 !important;
          }
        }
      }
    }
    .edit-btn {
      background: #f8f8f8;
      border: 1px solid #f5f5f5;
    }
  }
  .level-template {
    .btn-wrapper {
      margin-bottom: 15px;
      text-align: right;
      .add-new-btn {
        background: #00a791 !important;
        color: #fff !important;
      }
    }
    .level-box {
      display: flex;
      align-items: left;
      flex-direction: column;
      .default {
        background: #e1554f;
        padding: 4px 6px 3px;
        border-radius: 15px;
        color: #fff;
        width: 90px;
        text-align: center;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
